import { createSlice } from "@reduxjs/toolkit";

export const keysegmentsAndStorylinesSlice = createSlice({
  name: "keysegmentsAndStorylinesState",
  initialState: {
    currentKeysegment: null,
    currentStoryline: null,
    showStorylinesComponent: false,
  },
  reducers: {
    updateCurrentKeysegment: (state, action) => {
      state.currentKeysegment = action.payload;
    },
    updateCurrentStoryline: (state, action) => {
      state.currentStoryline = action.payload;
    },
    toggleKeysegmentsAndStorylinesView: (state, action) => {
      state.showStorylinesComponent = action.payload;
    },
  },
});

export const {
  updateCurrentKeysegment,
  updateCurrentStoryline,
  toggleKeysegmentsAndStorylinesView,
} = keysegmentsAndStorylinesSlice.actions;

export default keysegmentsAndStorylinesSlice.reducer;
